import { Outlet } from 'react-router'
import PageLayout from '@/layouts/PageLayout'

const Page = () => {
  return (
    <PageLayout>
      <div className="flex flex-1 w-full">
        <main className="flex-1 overflow-hidden">
          <Outlet />
        </main>
      </div>
    </PageLayout>
  )
}

export default Page
